import { AuthApplicationIds } from '@common/models/Enums';
import { IModel, Model } from '../Model';

export interface IAuthApplicationModel extends IModel {
  authApplicationId: number;
  description: string;
  key: string;
  isFilterable: boolean;
  isViewable: boolean;
}

export class AuthApplicationModel
  extends Model
  implements IAuthApplicationModel
{
  authApplicationId: number;
  description: string;
  key: string;
  isFilterable: boolean;
  isViewable: boolean;

  constructor(params: Partial<IAuthApplicationModel>) {
    super(params);
    const {
      authApplicationId = 0,
      description = '',
      key = '',
      isFilterable = false,
      isViewable = false,
    } = params;

    this.authApplicationId = authApplicationId;
    this.description =
      authApplicationId > Object.keys(AuthApplicationIds).length
        ? description
        : AuthApplicationIds[authApplicationId];
    this.key = key;
    this.isFilterable = isFilterable;
    this.isViewable = isViewable;
  }
}
